<template>
  <ul :class="{'main-nav__submenu--open': open }" class="main-nav__submenu">
    <router-link :to="{ name: 'reservationGroup', params: { reservationId: this.$route.params.reservationId } }" tag="li" exact>
      <li>
        <a href="#">Gruppenreservierung</a>
      </li>
    </router-link>
    <router-link :to="{ name: 'reservation2', params: { reservationId: this.$route.params.reservationId } }" tag="li" exact>
      <li>
        <a href="#">Bucher</a>
      </li>
    </router-link>
    <router-link :to="{ name: 'reservation', params: { reservationId: this.$route.params.reservationId } }" :class="[ 'main-nav__hr' ]" tag="li" exact>
      <li>
        <a href="#">Übersicht</a>
      </li>
    </router-link>
    <router-link :to="{ name: 'reservation2', params: { reservationId: this.$route.params.reservationId } }"
                 :class="[ 'main-nav__hr' ]"
                 tag="li"
                 exact>
      <li>
        <a href="#">Nächte/Preise</a>
      </li>
    </router-link>
    <router-link :to="{ name: 'reservation2', params: { reservationId: this.$route.params.reservationId } }" tag="li" exact>
      <li>
        <a href="#">Meldeblätter</a>
      </li>
    </router-link>
    <router-link :to="{ name: 'reservation2', params: { reservationId: this.$route.params.reservationId } }" :class="[ 'main-nav__hr' ]" tag="li" exact>
      <li>
        <a href="#">Hauptgast</a>
      </li>
    </router-link>
    <router-link :to="{ name: 'reservation2', params: { reservationId: this.$route.params.reservationId } }" tag="li" exact>
      <li>
        <a href="#">Firma</a>
      </li>
    </router-link>
    <router-link :to="{ name: 'reservation2', params: { reservationId: this.$route.params.reservationId } }" tag="li" exact>
      <li>
        <a href="#">Reisebüro</a>
      </li>
    </router-link>
    <router-link :to="{ name: 'reservation2', params: { reservationId: this.$route.params.reservationId } }" tag="li" exact>
      <li>
        <a href="#">Zahler</a>
      </li>
    </router-link>
    <router-link :to="{ name: 'reservation2', params: { reservationId: this.$route.params.reservationId } }" :class="[ 'main-nav__hr' ]" tag="li" exact>
      <li>
        <a href="#">Reservierungsfolios</a>
      </li>
    </router-link>
    <router-link :to="{ name: 'reservation2', params: { reservationId: this.$route.params.reservationId } }" :class="[ 'main-nav__submenu__li--level-1' ]" tag="li" exact>
      <li>
        <a href="#">- &nbsp; Folio 1</a>
      </li>
    </router-link>
    <router-link :to="{ name: 'reservation2', params: { reservationId: this.$route.params.reservationId } }" :class="[ 'main-nav__hr' ]" tag="li" exact>
      <li>
        <a href="#">Sammelrechnung</a>
      </li>
    </router-link>
    <router-link :to="{ name: 'reservation2', params: { reservationId: this.$route.params.reservationId } }" :class="[ 'main-nav__submenu__li--level-1' ]" tag="li" exact>
      <li>
        <a href="#">- &nbsp; Folio 1</a>
      </li>
    </router-link>
    <router-link :to="{ name: 'reservation2', params: { reservationId: this.$route.params.reservationId } }" :class="[ 'main-nav__hr' ]" tag="li" exact>
      <li>
        <a href="#">Korrespondenz</a>
      </li>
    </router-link>
    <router-link :to="{ name: 'reservation2', params: { reservationId: this.$route.params.reservationId } }" tag="li" exact>
      <li>
        <a href="#">Bearbeitungsverlauf</a>
      </li>
    </router-link>
  </ul>
</template>

<script>

import { isEmpty, isNil } from 'lodash';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import UpdateHotelSettingsMixin from '../../../../mixins/UpdateHotelSettingsMixin';

export default {
  name: 'GenericSubNav',

  mixins: [HotelmeisterMixin, UpdateHotelSettingsMixin],

  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
    };
  },

  computed: {
  },

  created: function () {
  },

  mounted: function () {
  },

  methods: {
    env: function (name) {
      return process.env[name];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/ReservationSubNav.vue